<template>
    <CustomDialog
        :value="value"
        @input="$emit('input', $event)"
        :defaultTitle="$t('profil.password_modal.title')"
        :heightClass="`ppv2-max-h-[85vh]`"
        height="auto"
        centerContent
    >
        <template #content>
            <div class="ppv2-grid ppv2-grid-cols-1" :style="{ gap: normalizeSize(16, true) }">
                <!-- Current Password -->
                <BaseInput
                    v-model="form.current_password"
                    type="password"
                    :label="$t('profil.password_modal.current')"
                    :placeholder="$t('profil.password_modal.current_placeholder')"
                    required
                    classContainerAdd="ppv2-w-full"
                    :error="errors.current_password ? errors.current_password[0] : null"
                />

                <!-- New Password -->
                <BaseInput
                    v-model="form.password"
                    type="password"
                    :label="$t('profil.password_modal.new')"
                    :placeholder="$t('profil.password_modal.new_placeholder')"
                    required
                    classContainerAdd="ppv2-w-full"
                    :error="errors.password ? errors.password[0] : null"
                />

                <!-- Confirm Password -->
                <BaseInput
                    v-model="form.password_confirmation"
                    type="password"
                    :label="$t('profil.password_modal.confirm')"
                    :placeholder="$t('profil.password_modal.confirm_placeholder')"
                    required
                    classContainerAdd="ppv2-w-full"
                    :error="errors.password_confirmation ? errors.password_confirmation[0] : null"
                />
            </div>
        </template>
        <template #actions>
            <BaseButton
                variant="primary"
                @click="save"
                :customClass="`!ppv2-h-[45px] !ppv2-min-w-[170px] !ppv2-bg-[#7D2DBD]`"
                :disabled="isSaving"
            >
                {{ isSaving ? $t('common.saving') : $t('common.validate') }}
            </BaseButton>
        </template>
    </CustomDialog>
</template>

<script>
import normalizeSize from '../../../utils/normalizeSize'

import BaseButton from '../../Shared/BaseButton.vue'
import BaseInput from '../../Shared/BaseInput.vue'
import CustomDialog from '../../Shared/CustomDialog.vue'

export default {
    name: 'PasswordModal',
    components: {
        BaseButton,
        BaseInput,
        CustomDialog,
    },
    props: {
        value: { type: Boolean, required: true },
        isSaving: { type: Boolean, default: false },
        errors: { type: Object, default: () => ({}) },
    },
    data() {
        return {
            form: {
                current_password: '',
                password: '',
                password_confirmation: '',
            },
        }
    },
    watch: {
        value(val) {
            if (!val) {
                this.resetForm()
            }
        },
    },
    methods: {
        normalizeSize,
        save() {
            this.$emit('save', this.form)
        },
        resetForm() {
            this.form = {
                current_password: '',
                password: '',
                password_confirmation: '',
            }
        },
    },
}
</script>
